import { DataContext } from '../../data/DataContext';
import { useContext } from 'react';
import { RadioButton, Input, DateControl } from '../controls'
import { GetQuestion } from '../../data/MochaData';

const StepWorkData = () => {

    const { CVS, setCVS, changeHandler } = useContext(DataContext);

    const changeChk = (question: string, value: boolean) => setCVS({ ...CVS, [question]: value });
    
    const onChangeDate = (question: string, value: Date) => setCVS({ ...CVS, [question]: value });
     


    return (

        <div className="step-cvs">
            <div className="step-container-cvs">
                <div className="lbl-paso-t1 mt10">
                    <span className="">Detalles personales</span>
                </div>
                <div className="mt-10">
                    <span className="lbl-paso-t2">(*) Espacios requeridos</span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="lbl-paso-t3">Es necesario que respondas a las siguientes preguntas para gestionar tu cotización</span>
                </div>
                <RadioButton label={GetQuestion('dp_p1_p1')} field={'dp_p1_p1'} onChange={changeChk} isCheked={CVS.dp_p1_p1} />

                {(CVS.dp_p1_p1 && CVS.dp_p1_p1 !== undefined) && <RadioButton label={GetQuestion('dp_p1_p1_1b')} field={'dp_p1_p1_1b'} onChange={changeChk} isCheked={CVS.dp_p1_p1_1b} />}
                {(CVS.dp_p1_p1 && CVS.dp_p1_p1 !== undefined) && <Input id='dp_p1_p1_2b' label={GetQuestion('dp_p1_p1_2b')} placeholder='Ejemplo: Mercadería' field='dp_p1_p1_2b' value={CVS.dp_p1_p1_2b} onChange={changeHandler} />}

                {(!CVS.dp_p1_p1 && CVS.dp_p1_p1 !== undefined) && <RadioButton label={GetQuestion('dp_p1_p1_1a')} field={'dp_p1_p1_1a'} onChange={changeChk} isCheked={CVS.dp_p1_p1_1a} />}
                {(!CVS.dp_p1_p1 && CVS.dp_p1_p1 !== undefined) && <DateControl id='dp_p1_p1_2a' label={GetQuestion('dp_p1_p1_2a')} onChange={onChangeDate} value={CVS.dp_p1_p1_2a} placeholder='Ingresar fecha' isRequired={CVS.dp_p1_p1_1a} />}
                {(!CVS.dp_p1_p1 && CVS.dp_p1_p1 !== undefined) && <Input id='dp_p1_p1_3a' label={GetQuestion('dp_p1_p1_3a')} placeholder='País de la empresa' field='dp_p1_p1_3a' value={CVS.dp_p1_p1_3a} onChange={changeHandler} />}

                {CVS.dp_p1_p1 !== undefined && <Input type='number' id='dp_p1_p2' label={GetQuestion('dp_p1_p2')} placeholder='Ingresar horas' field='dp_p1_p2' value={CVS.dp_p1_p2} onChange={changeHandler} />}
                {CVS.dp_p1_p1 !== undefined && <RadioButton label={GetQuestion('dp_p1_p3')} field={'dp_p1_p3'} onChange={changeChk} isCheked={CVS.dp_p1_p3} />}

            </div>
        </div>

    );
}

export { StepWorkData };